import { render } from "./FortnoxInvoiceTable.vue?vue&type=template&id=351f61c7&scoped=true"
import script from "./FortnoxInvoiceTable.vue?vue&type=script&lang=js"
export * from "./FortnoxInvoiceTable.vue?vue&type=script&lang=js"

import "./FortnoxInvoiceTable.vue?vue&type=style&index=0&id=351f61c7&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351f61c7"]])

export default __exports__